import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';
import { format } from '../../../utils/format';

// ----------------------------------------------------------------------

const decode = (disposition: string) => {
  const fileName = decodeURI(
    disposition
      .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
      .replace(/['"]/g, '')
  );
  return fileName.normalize('NFC');
};

// ----------------------------------------------------------------------

const downloadInquiry = async (
  id: string,
  startDate: Date,
  endDate: Date,
  interval: string,
  rawData: boolean
) => {
  const start = format(startDate, interval === 'setting' ? 'daily' : interval, 'start');
  const end = format(endDate, interval === 'setting' ? 'daily' : interval, 'end');

  return await axios.get(`data-inquiry/iot-devices/${id}/download?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&rawData=${rawData}`, { responseType: 'blob' })
    .then((response) => {
      const url = URL.createObjectURL(response.data);
      
      const link = document.createElement('a');
      link.href = url;
      link.style.display = 'none';
      
      link.download = decode(response.headers['content-disposition']);
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      URL.revokeObjectURL(url);
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return Promise.reject(error);
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default downloadInquiry;